var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyllabusLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.6V19.6M12.5 19.6L10.25 17.2667M12.5 19.6L14.75 17.2667M7.1 18.4333C5.11178 18.4333 3.5 16.7917 3.5 14.7667C3.5 13.098 4.59438 11.6897 6.09198 11.2457C6.15562 11.2268 6.2 11.1675 6.2 11.1C6.2 8.06241 8.61766 5.59998 11.6 5.59998C14.5823 5.59998 17 8.06241 17 11.1C17 11.1582 17.0536 11.2014 17.1094 11.1887C17.3638 11.1306 17.6284 11.1 17.9 11.1C19.8882 11.1 21.5 12.7416 21.5 14.7667C21.5 16.7917 19.8882 18.4333 17.9 18.4333",
    stroke: "#04236B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyllabusLogo);
export default __webpack_public_path__ + "static/media/syllabus_logo.7217b002acafd592cf4f19083dbedada.svg";
export { ForwardRef as ReactComponent };